import {
  ApplicationType,
  ApplicationTypeEnum,
} from '../../types/ApplicationV3/application';

export const BACKEND_DEFAULT_APPLICATION_TYPE = 0;

const FRONTEND_TO_BACKEND_APPLICATION_TYPE: Record<
  ApplicationTypeEnum,
  number
> = {
  [ApplicationTypeEnum.OngoingEmployment]: 0,
  [ApplicationTypeEnum.EndedFixedTermEmployment]: 1,
  [ApplicationTypeEnum.DismissedDueToSickness]: 2,
  // No direct backend equivalent exists for this selection in current API.
  [ApplicationTypeEnum.DismissedFromPermanentEmployment]: 2,
  // Completion is a frontend flow mode, fallback to a valid backend enum value.
  [ApplicationTypeEnum.CompletionForApplication]: 0,
};

const NUMBER_TO_FRONTEND_APPLICATION_TYPE: Record<number, ApplicationTypeEnum> =
  {
    0: ApplicationTypeEnum.OngoingEmployment,
    1: ApplicationTypeEnum.EndedFixedTermEmployment,
    2: ApplicationTypeEnum.DismissedDueToSickness,
    3: ApplicationTypeEnum.DismissedFromPermanentEmployment,
    4: ApplicationTypeEnum.CompletionForApplication,
  };

export const toFrontendApplicationType = (
  raw: unknown
): ApplicationType | undefined => {
  if (typeof raw === 'string') {
    const parsed = Number(raw);
    if (!Number.isInteger(parsed)) {
      return undefined;
    }

    return NUMBER_TO_FRONTEND_APPLICATION_TYPE[parsed];
  }

  if (typeof raw === 'number') {
    return NUMBER_TO_FRONTEND_APPLICATION_TYPE[raw];
  }

  return undefined;
};

export const toBackendApplicationType = (
  raw: ApplicationType | string | number | undefined | null
): number => {
  const frontendType = toFrontendApplicationType(raw);
  if (!frontendType) {
    return BACKEND_DEFAULT_APPLICATION_TYPE;
  }

  return FRONTEND_TO_BACKEND_APPLICATION_TYPE[frontendType];
};
